export class FoodOpsApi {
    client;
    constructor(client) {
        this.client = client;
    }
    /** Open an intervention on a live target (operator). */
    openIntervention(input) {
        return this.client.request({ method: 'POST', path: '/v1/food-ops/interventions', body: input, auth: true });
    }
    /** List a target's interventions, newest first (operator). */
    listByTarget(targetRef) {
        return this.client.request({ method: 'GET', path: `/v1/food-ops/interventions?targetRef=${encodeURIComponent(targetRef)}`, auth: true });
    }
    /** List every unresolved intervention (operator). */
    listOpen() {
        return this.client.request({ method: 'GET', path: '/v1/food-ops/interventions?status=open', auth: true });
    }
    /** Acknowledge an open intervention (operator). */
    acknowledge(interventionId) {
        return this.client.request({ method: 'POST', path: `/v1/food-ops/interventions/${encodeURIComponent(interventionId)}/acknowledge`, body: {}, auth: true });
    }
    /** Escalate an intervention with a new reason code (operator). */
    escalate(interventionId, reasonCode) {
        return this.client.request({ method: 'POST', path: `/v1/food-ops/interventions/${encodeURIComponent(interventionId)}/escalate`, body: { reasonCode }, auth: true });
    }
    /** Resolve an intervention (append-only; operator). */
    resolve(interventionId, resolutionNote) {
        return this.client.request({ method: 'POST', path: `/v1/food-ops/interventions/${encodeURIComponent(interventionId)}/resolve`, body: { resolutionNote }, auth: true });
    }
}
//# sourceMappingURL=food-ops.js.map